import { render, staticRenderFns } from "./backtoschool.vue?vue&type=template&id=7e287a6e&"
import script from "./backtoschool.vue?vue&type=script&lang=js&"
export * from "./backtoschool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports